export default __webpack_public_path__ + "static/media/img_post6_4.946390b8.png";